import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Individual } from '../model/individual';
import { PackageModel } from '../model/package.model';
import { WizardService } from '../wizard/wizard.service';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { tap } from 'rxjs';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {

  public faArrowsRotate = faArrowsRotate;

  public Package: PackageModel = null;

  public modal: BsModalRef;
  public form: UntypedFormGroup;

  public acknowledgementsComplete: boolean = false;
  public SMSOptedIn: boolean = false;

  @ViewChild('espanol')
  public Espanol: TemplateRef<any>;

  public get Individual(): Individual {
    return this.wizard.Individual;
  }

  constructor(
    private wizard: WizardService,
    private modalService: BsModalService
  ) {
  }

  public ngOnInit(): void {
    this.Package = this.wizard.Package;

    this.SMSOptedIn = this.wizard.Individual.cst_sms_opt == "Opt In";


    this.form = new FormGroup({
      SMSOptin: new FormControl(this.SMSOptedIn, [])
    });
  }

  public Agree(): void {
    if(this.form.value.SMSOptin) {
      this.wizard.Individual.cst_sms_opt = "Opt In";
      this.wizard.OptInSMS('wizard-terms').subscribe();
    }
    this.wizard.TermsAgreement = new Date();
  }

  public UpdateAcknowledgements(acknowledgements: any): void {
    this.acknowledgementsComplete = acknowledgements.filter(a => a.Required && !a.Acknowledged).length == 0;
    acknowledgements.filter(a => a.Acknowledged).forEach(ack => {
      this.wizard.SetAdditionalAcknowledgement(ack.Key);
    });
  }

  public showEspanol(event: Event): void {
    event.preventDefault();

    this.modal = this.modalService.show(this.Espanol);
  }
}
